<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名" prop="nickname">
          <a-input placeholder="请输入姓名" v-model="model.nickname"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号" prop="phone">
          <a-input placeholder="请输入手机号" v-model="model.phone"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录账号" prop="username">
          <a-input placeholder="请输入登录账号" v-model="model.username"></a-input>
        </a-form-model-item>

        <template v-if="!model.id">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="登录密码" prop="password">
            <a-input placeholder="请输入登录密码" type="password" v-model="model.password" />
          </a-form-model-item>

          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="确认密码" prop="confirmpassword">
            <a-input @blur="handleConfirmBlur" placeholder="请重新输入登录密码" type="password" v-model="model.confirmpassword" />
          </a-form-model-item>
        </template>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属企业" prop="corpId">
          <j-dict-select-tag
            :disabled="corpDisAbled"
            @change="corpChange"
            dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
            placeholder="请选择所属企业"
            type="list"
            v-model="model.corpId"
          />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="班组" prop="groupId">
          <a-row>
              <a-col :span="18" class="pr-8px">
                <j-search-select-tag
                  :dictOptions="groupOptions"
                  placeholder="请选择班组"
                  v-model="model.groupId"
                ></j-search-select-tag>
              </a-col>
              <a-col :span="6">
                <a-button @click="handleGroupAdd" class="ml-8px" icon="plus" type="primary">新增</a-button>
              </a-col>
            </a-row>
        </a-form-model-item> 
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否禁用" prop="disabled">
          <j-switch :options="[1, 0]" v-model="model.disabled"></j-switch>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="头像" prop="avatar">
          <j-image-upload class="avatar-uploader" text="上传" v-model="model.avatar"></j-image-upload>
        </a-form-model-item>
<!--         
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="性别" prop="sex">
          <j-dict-select-tag dictCode="sex" placeholder="请选择性别" type="radio" v-model="model.sex" />
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生日" prop="birthday">
          <j-date placeholder="请选择生日" style="width: 100%" v-model="model.birthday" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="微信用户ID" prop="wechatUserId">
          <a-input placeholder="请输入微信用户ID" v-model="model.wechatUserId"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="QQ用户ID" prop="qqUserId">
          <a-input placeholder="请输入QQ用户ID" v-model="model.qqUserId"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="支付宝用户ID" prop="alipayUserId">
          <a-input placeholder="请输入支付宝用户ID" v-model="model.alipayUserId"></a-input>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="钉钉用户ID" prop="dingtalkUserId">
          <a-input placeholder="请输入钉钉用户ID" v-model="model.dingtalkUserId"></a-input>
        </a-form-model-item> -->
      </a-form-model>
    </j-form-container>

    <wf-consumer-corp-group-modal ref="groupModalForm" @ok="modalFormOk"></wf-consumer-corp-group-modal>
  </a-spin>
</template>

<script>
  import { duplicateCheck } from '@/api/api'
  import { httpAction, getAction } from '@/api/manage'
  import WfConsumerCorpGroupModal from '@/views/wf/modules/WfConsumerCorpGroupModal'

    const validateMap = {
      "username": {
        tableName: "`iwt-wf`.wf_consumer_user",
        fieldName: "username",
        fieldComment: "登录账号",
      },
      "phone": {
        tableName: "`iwt-wf`.wf_consumer_user",
        fieldName: "phone",
        fieldComment: "手机号",
      }
    }

  export default {
    name: 'WfConsumerUserForm',
    components: {
      WfConsumerCorpGroupModal
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          sex: 1,
          disabled: 0,
          userStatus: 1, //新增账号正常可用
        },
        groupOptions: [],
        corpDisAbled: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/custom/user/add",
          edit: "/custom/user/edit",
          queryById: "/custom/user/queryById",
          corpGroupList: "/wf/corpGroup/list"
        },
        confirmDirty: false,
        validatorRules: {
          username: [{ required: true, message: '请输入用户账号!' }, { validator: this.validateDuplicate, }],
          password: [
            { required: true, message: '密码不能为空!' },
            // { required: true, pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/, message: '密码由8位以上数字、大小写字母组成!' },
            { validator: this.validateToNextPassword, trigger: 'change' }],
          confirmpassword: [{ required: true, message: '请重新输入登录密码!', },
          { validator: this.compareToFirstPassword, }],
          nickname: [{ required: true, message: '请输入用户姓名!' }],
          phone: [{ required: true, message: '请输入手机号!' }, { validator: this.validateDuplicate }],
          corpId: [{ required: true, message: '请选择所属企业!' }],
          email: [{ validator: this.validateEmail }],
          roles: {},
          telephone: [{ pattern: /^0\d{2,3}-[1-9]\d{6,7}$/, message: '请输入正确的座机号码' },]
        },
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add (given) {
        if(given?.corpId){
          this.corpDisAbled = true;
        }
        this.edit(Object.assign({}, given, this.modelDefault));
      },
      edit (record) {
        this.corpDisAbled = !!record.corpId;

        this.model = Object.assign({}, record);

        this.getGroup();
        this.visible = true;
      },
      corpChange(){
        this.getGroup();
      },
      getGroup(){
        this.groupOptions =[];
        const params = { 
          pageSize: 999999,
          corpId: this.model.corpId
         };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.groupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      validateToNextPassword (rule, value, callback) {
        const confirmpassword = this.model.confirmpassword;
        if (value && confirmpassword && value !== confirmpassword) {
          callback('两次输入的密码不一样！');
        }
        if (value && this.confirmDirty) {
          this.$refs.form.validateField(['confirmpassword']);
        }
        callback();
      },
      compareToFirstPassword (rule, value, callback) {
        if (value && value !== this.model.password) {
          callback('两次输入的密码不一样！');
        } else {
          callback()
        }
      },
      handleConfirmBlur (e) {
        const value = e.target.value;
        this.confirmDirty = this.confirmDirty || !!value
      },
      validateDuplicate (rule, value, callback) {
        const checkParams = validateMap[rule.field];
        var params = {
          tableName: checkParams.tableName,
          fieldName: checkParams.fieldName,
          fieldVal: value,
          dataId: this.model.id
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(`${checkParams.fieldComment}已存在!`)
          }
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleGroupAdd(){
        this.$refs.groupModalForm.title = '新增班组'
        this.$refs.groupModalForm.add();
      },
      modalFormOk(){
        this.getGroup();
      }
    }
  }
</script>